import images from "@/assets/images";

interface ITVComponentProps {
  next: () => void;
}
const TVComponent: React.FC<ITVComponentProps> = ({ next }) => {
  return (
    <div className="hide-scroll-bar mx-[33px] flex max-h-full flex-col items-center overflow-y-auto pb-[30px] pt-[64px]">
      <img className="mb-[52px] w-full" src={images.PC3} />;
      <div className="mb-[8px] flex w-max items-center justify-center rounded-[4px] bg-[#FFFFFF0D] px-[12px] py-[4px] text-[12px] leading-[22px] text-[#FFFFFF99]">
        TV客户端
      </div>
      <p className="mb-[8px] text-[16px] leading-[22px] text-[#FFF]">云视听虎电竞</p>
      <p className="mb-[20px] text-[32px] leading-[45px] text-[#fff]">畅享大屏蓝光体验</p>
      <p className="mb-[4px] text-[14px] leading-[20px] text-[#FFFFFF99]">请在电脑访问操作</p>
      <p className="mb-[50px] text-[14px] leading-[22px] text-[#FFFFFF99]">
        https://hd.huya.com/download/
      </p>
      <img src={images.iconDown1} className="h-[24px] w-[24px]" onClick={next} />
    </div>
  );
};

export default TVComponent;
